import PropTypes from "prop-types";
import React from "react";
import styles from "./Settings.module.css";

import { SettingsListItem } from "../../components/SettingsListItem/SettingsListItem";
import { useTranslation } from "react-i18next";

export const Settings = ({}) => {
  const {t} = useTranslation();

  const emeraldList = [
    {
      name: "Jim & Pam Arnold",
    },
    {
      name: "Sam & Wendy Bauer",
    },
    {
      name: "Joel Brandt",
    },
    {
      name: "Susan Campbell",
    },
    {
      name: "Louis & Sabrina Cooper",
    },
    {
      name: "Dennis Dart",
    },
    {
      name: "Eliza Ellis",
    },
    {
      name: "Colin & Sara Ewing",
    },
  ];

  const platinumList = [
    {
      name: "Jim & Pam Arnold",
    },
    {
      name: "Sam & Wendy Bauer",
    },
    {
      name: "Joel Brandt",
    },
    {
      name: "Susan Campbell",
    },
    {
      name: "Louis & Sabrina Cooper",
    },
    {
      name: "Dennis Dart",
    },
    {
      name: "Eliza Ellis",
    },
    {
      name: "Colin & Sara Ewing",
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.settingsList}>
        <div className={styles.header}>{t("Emerald Settings")}</div>
        <div className={styles.subHeader}>
          {t("Allow these Emeralds to view the info of")}
        </div>
        {emeraldList.map((item) => (
          <SettingsListItem green={true} name={item.name} />
        ))}
      </div>

      <div className={styles.settingsList}>
        <div className={styles.header}>{t("Platinum Settings")}</div>
        <div className={styles.subHeader}>
          {t("Allow these Platinums to view the info of")}
        </div>
        {platinumList.map((item) => (
          <SettingsListItem green={false} name={item.name} />
        ))}
      </div>
    </div>
  );
};

Settings.propTypes = {};
